<template>
  <HeaderPopup v-bind:onCloseClick="sentSuccessfully ? null : onCloseClick">
    <div class="ask-block">
      <div class="title">General Inquiries</div>
      <div class="success-block" v-if="sentSuccessfully">
        <SentIcon class="success-block__icon" />
        <div class="sent-title">Thank You!</div>
        <div class="sent-text">
          Your message has been sent. We will try to reach you ASAP!
        </div>
        <CtaButton
          class="close-button"
          label="Close"
          v-bind:onClick="closeSentSuccessfully"
        />
      </div>

      <div class="names-info">
        <div class="field">
          <FormInput
            label="your NAME*"
            placeholder="Full Name"
            :value="nameField.value"
            v-bind:onChange="(value) => nameField.setValue(value)"
            :validate="nameField.validate"
            :error-text="nameField.errorText"
          />
        </div>
        <div class="field">
          <FormInput
            label="company name"
            placeholder="Not Mandatory"
            :value="companyField.value"
            v-bind:onChange="(value) => companyField.setValue(value)"
            :validate="() => false"
          />
        </div>
      </div>

      <div>
        <FormInput
          label="email*"
          placeholder="example@yourdomain.com"
          :value="emailField.value"
          v-bind:onChange="(value) => emailField.setValue(value)"
          :validate="emailField.validate"
          :error-text="emailField.errorText"
        />
      </div>

      <div>
        <FormInput
          label="PHONE number*"
          :value="phoneField.value"
          v-bind:onChange="(value) => phoneField.setValue(value)"
          :validate="phoneField.validate"
          :error-text="phoneField.errorText"
        />
      </div>

      <div>
        <FormInput
          label="WEBSITE"
          :value="websiteField.value"
          v-bind:onChange="(value) => websiteField.setValue(value)"
          :validate="websiteField.validate"
          :error-text="websiteField.errorText"
        />
      </div>

      <FormChipsSelector
        title="how to reach you?*"
        :options="['WhatsApp', 'Telegram', 'Email']"
        :value="contactChannelField.value"
        :onChange="contactChannelField.setValue"
      />

      <div class="label">MESSAGE</div>
      <TextField
        class="message-area"
        :value="messageField.value"
        placeholder="Looking to integrate our sportsbook? Share the details here..."
        v-bind:onChange="(value) => messageField.setValue(value)"
        v-bind:onBlur="messageField.validate"
      />
      <FieldError
        :text="messageField.errorText"
        v-if="messageField.errorText"
      />

      <div @click="validateRequired">
        <CtaButton
          v-bind:disabled="!isFormValid"
          :class="['button', { ['notInteractive']: !isFormValid }]"
          label="Send a message"
          v-bind:onClick="handleSendClick"
        />
      </div>
      <div class="recaptha-terms">
        This site is protected by reCAPTCHA and the Google
        <a href="https://policies.google.com/privacy" class="recaptha-link">
          Privacy Policy
        </a>
        <br />
        and
        <a href="https://policies.google.com/terms" class="recaptha-link">
          Terms of Service
        </a>
        apply.
      </div>
    </div>
  </HeaderPopup>
</template>

<script>
import HeaderPopup from "./HeaderPopup";
import Input from "../form/Input";
import FormInput from "../form/FormInput.vue";
import TextField from "../form/TextField";
import FieldError from "../form/FieldError";
import CtaButton from "./CtaButton";
import SentIcon from "../icons/SentIcon";
import FormChipsSelector from "../form/FormChipsSelector.vue";
import { useContactUsForm } from "../../helpers/useContactUsForm";

const API_URL = 'https://betby.com/form'
const RECAPTCHA_KEY = '6LdACG0rAAAAAFoXuPUn0YXO7GvmGquXy7kKzMms'

const sendForm = (body) =>
  fetch(API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  })
    .then((res) => (res.status === 200 ? res.json() : Promise.reject()))
    .then((data) => data.success || Promise.reject());

export default {
  name: "AskBlock",
  components: {
    SentIcon,
    HeaderPopup,
    Input,
    FormInput,
    TextField,
    CtaButton,
    FieldError,
    FormChipsSelector,
  },
  props: {
    onCloseClick: Function,
  },
  data() {
    const {
      nameField,
      companyField,
      emailField,
      phoneField,
      websiteField,
      contactChannelField,
      messageField,
      onSubmit,
    } = useContactUsForm();

    return {
      nameField,
      companyField,
      emailField,
      phoneField,
      websiteField,
      contactChannelField,
      messageField,
      onSubmit,
      errors: {},
      sentSuccessfully: false,
    };
  },
  computed: {
    isFormValid() {
      return (
        this.nameField.value.length &&
        !this.nameField.errorText &&
        this.emailField.value.length &&
        !this.emailField.errorText &&
        this.phoneField.value.length &&
        !this.phoneField.errorText &&
        !this.websiteField.errorText &&
        this.messageField.value.length &&
        !this.messageField.errorText &&
        this.contactChannelField.value
      );
    },
  },
  methods: {
    validateRequired() {
      this.nameField.validate();
      this.emailField.validate();
      this.phoneField.validate();
      this.messageField.validate();
    },
    handleSendClick() {
      if (this.isFormValid) {
        window.grecaptcha.enterprise.ready(() => {
          grecaptcha.enterprise
            .execute(RECAPTCHA_KEY, { action: "LOGIN" })
            .then((token) => {
              sendForm({
                recaptcha: token,
                name: this.nameField.value,
                companyName: this.companyField.value,
                email: this.emailField.value,
                phoneNumber: this.phoneField.value,
                website: this.websiteField.value,
                contactChannel: this.contactChannelField.value,
                message: this.messageField.value,
              })
                .then(() => {
                  this.setSentSuccessfully();
                })
                .finally(() => {
                  this.messageField.setValue('')
                });
            });
        });
      }
    },
    setSentSuccessfully() {
      this.sentSuccessfully = true;

      setTimeout(this.closeSentSuccessfully, 4000);
    },
    closeSentSuccessfully() {
      this.sentSuccessfully = false;
    },
  },
};
</script>

<style scoped>
.ask-block {
  position: relative;
  width: 375px;
  max-width: 100%;
  padding: 8px 8px 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.title {
  color: #000025;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px; /* 145.455% */
}
.message-area {
  resize: none;
  height: 136px;
  font-family: "sofia-pro", sans-serif;
  color: #000025;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px; /* 150% */
  width: 100%;
  box-sizing: border-box;
  outline: none;
  border: 2px solid rgba(0, 0, 37, 0.05);
  border-radius: 8px;
  padding: 8px;
  margin-top: 8px;

  &::placeholder {
    color: rgba(0, 0, 37, 0.5);
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }

  &:hover {
    outline: none;
    border: 2px solid rgba(0, 0, 37, 0.05);
  }

  &:focus {
    border: 2px solid #773dff;
    opacity: 1;
  }
}
.success-block {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  z-index: 1;
}
.success-block__icon {
  margin-bottom: 16px;
}
.names-info {
  display: flex;
  gap: 8px;
}
.label {
  color: #000025;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; /* 133.333% */
  letter-spacing: 2px;
  text-transform: uppercase;
  opacity: 0.5;
}
.label:first-of-type {
  margin-top: 0;
}
.button {
  margin-top: 8px;
}
.recaptha-terms {
  color: rgba(74, 74, 74, 0.5);
  font-size: 11px;
  line-height: 146.28%;
  text-align: center;
  margin-top: 16px;
  font-weight: 500;
  text-decoration: none;
}
.recaptha-link {
  color: #0821ff;
  text-decoration: none;
}

.notInteractive {
  pointer-events: none;
}

.sent-title {
  font-size: 18px;
  color: #1e313a;
  margin-bottom: 4px;
}
.sent-text {
  width: 205px;
  color: #929ca3;
}
.close-button {
  width: 180px;
  margin-top: 24px;
}

@media (max-width: 600px) {
  .ask-block {
    width: 100%;
  }
}
</style>
